import React, { useEffect, useState } from 'react';
import { countdownText } from './todayMath';

interface Props {
  /** Epoch ms of the next auto refresh. Remount (key) when it moves. */
  nextAt: number;
}

/**
 * "next in m:ss" until the next auto refresh. Its 1 s ticker lives here, so
 * only this text re-renders every second, not the page or the board.
 */
export const RefreshCountdown: React.FC<Props> = ({ nextAt }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(id);
  }, []);

  return <>next in {countdownText(nextAt - now)}</>;
};
